import { IconEdit } from "../../icons/IconEdit";
import { IconEllipsisVertical } from "../../icons/IconEllipsisVertical";
import { IconAdd } from "../../icons/IconAdd";
import { IconBell } from "../../icons/IconBell";
import "./circle-button.css";
import { IconTrash } from "../../icons/IconTrash";
import { IconFilter } from "../../icons/IconFilter";

type CircleButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  badgeCount?: number;
  ariaLabel?: string;
  iconKey?: string;
  size?: "small" | "medium" | "large";
  state?: "normal" | "active" | "disabled";
  buttonStyle?: "default" | "primary" | "secondary";
};

export const CircleButton = ({
  onClick,
  badgeCount,
  disabled = false,
  ariaLabel = "Circle Button",
  iconKey,
  size = "medium",
  state = "normal",
  buttonStyle = "default",
}: CircleButtonProps) => {
  const shouldShowBadge = badgeCount !== undefined && badgeCount > 0;

  return (
    <button
      className={`circle-button circle-button--${size} circle-button--${state} circle-button--style-${buttonStyle}`}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) {
          onClick();
        }
      }}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {iconKey && IconForButton(iconKey)}
      {shouldShowBadge && (
        <span className="circle-button__notification-badge">
          {badgeCount > 9 ? "9+" : badgeCount}
        </span>
      )}
    </button>
  );
};

const IconForButton = (key: string) => {
  switch (key) {
    case "edit":
      return <IconEdit />;
    case "bell":
      return <IconBell />;
    case "add":
      return <IconAdd />;
    case "ellipsis":
      return <IconEllipsisVertical />;
    case "trash":
      return <IconTrash />;
    case "filter":
      return <IconFilter />;
    // Add more cases as needed
    default:
      return null;
  }
};
